module.exports = __webpack_public_path__ + "static/vi-har-laerling-494548101223f0bfd3a474ccf4d51e61.jpg";